import { Wind, Activity, Sun, Smile, AlignCenter } from "lucide-react";

const benefits = [
  { icon: Wind, title: "Stress relief", text: "Soften chronic holding patterns and find a quieter inner landscape." },
  { icon: Activity, title: "Nervous system support", text: "Regulate the vagus nerve and return to safety in the body." },
  { icon: Sun, title: "Renewed energy", text: "Unlock the lifeforce that gets trapped in tension and bracing." },
  { icon: Smile, title: "Emotional wellbeing", text: "Move stored emotion gently — without forcing or pushing." },
  { icon: AlignCenter, title: "Body alignment", text: "Restore the natural undulation of the spine and breath." },
];

export default function WhatIs() {
  return (
    <section id="what" className="py-24 md:py-32 bg-card/40 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl reveal">
          <p className="text-xs uppercase tracking-[0.25em] text-secondary mb-4">A new way to heal</p>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight">
            What is <span className="italic">Spinal Flow?</span>
          </h2>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
            Spinal Flow is a gentle, hands-on healing modality that works with twelve access
            points along the spine to release stored tension and trauma. There is no cracking,
            no force — just listening, breath, and the body's natural intelligence guiding the way.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              className="reveal group rounded-3xl bg-background border border-border/60 p-7 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/10"
              style={{ transitionDelay: `${i * 60}ms` }}
              data-testid={`benefit-card-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-primary/40 inline-flex items-center justify-center mb-5 group-hover:bg-secondary/40 transition-colors">
                <b.icon size={20} className="text-foreground" />
              </div>
              <h3 className="font-serif text-2xl mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.text}</p>
            </div>
          ))}

          <div className="reveal rounded-3xl p-7 bg-gradient-to-br from-secondary/80 to-secondary text-secondary-foreground flex flex-col justify-between min-h-[220px]">
            <div className="font-serif text-2xl leading-snug">"The body whispers before it screams. Spinal Flow listens."</div>
            <div className="text-xs uppercase tracking-[0.2em] mt-6 opacity-90">— Farina</div>
          </div>
        </div>
      </div>
    </section>
  );
}
